import { render, staticRenderFns } from "./UserManagementForAdmin.vue?vue&type=template&id=71f1024d&scoped=true"
import script from "./UserManagementForAdmin.vue?vue&type=script&lang=js"
export * from "./UserManagementForAdmin.vue?vue&type=script&lang=js"
import style0 from "./UserManagementForAdmin.vue?vue&type=style&index=0&id=71f1024d&prod&scoped=true&lang=css"
import style1 from "./UserManagementForAdmin.vue?vue&type=style&index=1&id=71f1024d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f1024d",
  null
  
)

export default component.exports